import { rpx } from 'client/lib/rpx-client';
import { LoadedProps, RouteLoadProps } from '@components/router';

export async function load(route: RouteLoadProps) {
  const { courseId, seriesId } = route.params;
  const [course, data] = await Promise.all([
    rpx.courses.getGuideCourse({ id: courseId }),
    rpx.meetingSeries.getMeetingSeries({ courseId, seriesId }),
  ]);
  return {
    course,
    series: data.series,
    sessions: data.sessions,
  };
}

export type State = LoadedProps<typeof load>['state'];
